// Import necessary dependencies
import React, { useState, useEffect } from 'react';
import HeaderTop from '../components/headertop';
import SponsorsBar from './sponsorsbar'; // Capitalized to match file
import ReCAPTCHA from 'react-google-recaptcha';
import '../styles/contactus.scss';
import { useForm, ValidationError } from "@formspree/react";

// ContactUs component for handling contact form submissions
const ContactUs = () => {
  // State for reCAPTCHA value
  const [captchaValue, setCaptchaValue] = useState(null);
  // Initialize formspree form handling
  const [state, handleSubmit] = useForm("xblgzynn");

  // Handle reCAPTCHA value changes
  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
  };

  // Handle form submission
  const onSubmit = (e) => {
    e.preventDefault();
    // Verify CAPTCHA before submission
    if (!captchaValue) {
      alert('Please verify the CAPTCHA before submitting.');
      return;
    }
    handleSubmit(e);
  };

  // Scroll to top when form submission succeeds
  useEffect(() => {
    if (state.succeeded) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [state.succeeded]);

  return (
    <div className="contact-page">
      <HeaderTop />
      <SponsorsBar />
      <div className="contact-container">
        <h1>Contact Us or we can contact you</h1>

        {/* Show success message if form submission succeeded, otherwise show form */}
        {state.succeeded ? (
          <p className="success-message">
            ✅ Thanks! Your message has been sent.
          </p>
        ) : (
          <form onSubmit={onSubmit}>
            {/* Name input field */}
            <input id="name" type="text" name="name" placeholder="Your Name" required />
            <ValidationError prefix="Name" field="name" errors={state.errors} />

            {/* Email input field */}
            <input id="email" type="email" name="email" placeholder="Your Email" required />
            <ValidationError prefix="Email" field="email" errors={state.errors} />

            {/* Phone input field */}
            <input id="phone" type="tel" name="phone" placeholder="Contact Phone" required />
            <ValidationError prefix="Phone" field="phone" errors={state.errors} />

            {/* Message textarea */}
            <textarea
              id="message"
              name="message"
              placeholder="Your Message"
              rows="5"
              required
            />
            <ValidationError prefix="Message" field="message" errors={state.errors} />

            {/* reCAPTCHA verification */}
            {process.env.REACT_APP_RECAPTCHA_SITE_KEY ? (
              <ReCAPTCHA
                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                onChange={handleCaptchaChange}
              />
            ) : (
              <p style={{ color: 'red' }}>
                ⚠️ reCAPTCHA site key is missing. Please check your environment setup.
              </p>
            )}

            {/* Submit button */}
            <button type="submit" disabled={state.submitting}>
              Send
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ContactUs;
